import * as S from "./WithdrawInfo.style";

export const WithdrawInfo = () => {
  return (
    <S.WithdrowInfoBox>
      <S.Title>회원 탈퇴 안내</S.Title>
      <S.Text>
        서비스 탈퇴 요청 후 <span>영업일 기준 1주일 이내</span>로 회원정보는
        모두 삭제됩니다.
      </S.Text>
      <S.ContentBox>
        <S.Content>
          <span>삭제되는 정보</span>
          아이디, 이름, 생년월일, 성별, 전화번호, 학교정보(학교명, 학번), UID
        </S.Content>
        <S.Content>
          <span>처리 내용</span>
          회원 탈퇴 처리 시 일정 기간 비활성화 후 삭제
        </S.Content>
      </S.ContentBox>
    </S.WithdrowInfoBox>
  );
};
